import { forwardRef } from 'react'

interface SegmentedProgressChartProps {
  filled: number
  total: number
  color?: string
}

export const SegmentedProgressChart = forwardRef<HTMLDivElement, SegmentedProgressChartProps>(
  function SegmentedProgressChart(
    { filled, total, color = 'chart-1' }: SegmentedProgressChartProps,
    ref
  ) {
    // Edge case where the deal was opened today and expected to close today
    if (total == 0) {
      total = 1
      filled = 1
    }
    const clampedFilled = Math.min(total, Math.max(0, filled))

    return (
      <div ref={ref} className="flex h-2 w-full gap-0.5 overflow-hidden">
        {Array.from({ length: total }, (_, index) => (
          <div
            key={index}
            className="rounded bg-f1-foreground-disabled transition-all duration-300 ease-in-out flex-1"
            style={{
              backgroundColor: index < clampedFilled ? `hsl(var(--${color}))` : undefined,
            }}
          />
        ))}
      </div>
    )
  }
)
